import React, { useRef, useState, useEffect } from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

interface CustomerLogo {
  name: string;
  logo: string;
  url?: string;
}

interface CustomersProps {
  customers?: CustomerLogo[];
  title?: string;
  fallbackCustomers?: CustomerLogo[];
}

export const Customers: React.FC<CustomersProps> = ({ 
  customers,
  title,
  fallbackCustomers
}) => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const locale = searchParams.get('locale') || 'en';
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  
  // Check if we're on a tea product page
  const isTea = location.pathname.includes('tea');
  
  // Define default customers based on product type
  const teaCustomers = [
    { name: "Friend!", logo: "https://scontent-bom2-3.xx.fbcdn.net/v/t39.30808-6/470131160_18378461413107816_4348264077947766548_n.jpg?_nc_cat=110&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeFBnPylUTQNe9RyweMudskGNYPhReJ58441g-FF4nnzjgb6j7zOanWx3cmla9GdIFC2lAEyiRqFixRPVPqWIo3V&_nc_ohc=ASza-YE4g5IQ7kNvwHNFD3E&_nc_oc=Adlea2VPv_gSgvx8O3JroTl8x0pIxTFcVM7OCIFuBY1e9p_ZJoRM-xOPNBN4PUrbK9PxnPZnLwlKzb3fKWFvzTE1&_nc_zt=23&_nc_ht=scontent-bom2-3.xx&_nc_gid=4WdfGuIFr6gY52UB1gQKfQ&oh=00_AfN0jlvKAMWz6jat6ml-3E-0fIxGnn2kG4gWMNjDZewQ0Q&oe=686336F1", url: "" },
    { name: "Parents", logo: "https://scontent-bom2-1.xx.fbcdn.net/v/t39.30808-6/469904617_18378463792107816_5869626431727612355_n.jpg?_nc_cat=108&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeEiwSEGNJd_ZhtrIG1-M1Spin90y4RyGRyKf3TLhHIZHNz8azHzFzlVm0ESxl-N3atq5ugZ6r0EyPpvaJc3c7_M&_nc_ohc=IvHFhfapyfYQ7kNvwEGFuiL&_nc_oc=AdnwXomVH56imCmZm-dIxgm9EWjo9y4RkiJh18UM6KF_Vl0KdiqogMnv1qYOdMoWBMeIHQUbezGcMXx8ADYYKppr&_nc_zt=23&_nc_ht=scontent-bom2-1.xx&_nc_gid=wffNJ-H8ws2UUsZGDztL_w&oh=00_AfNjTVHMKYZvCYJTAg8FbW8t49ZgiuK4kFYPdD18t84-sg&oe=686361C0", url: "" },
    { name: "leaves!", logo: "https://scontent-bom2-3.xx.fbcdn.net/v/t39.30808-6/481995482_940521838244917_3729808799288854003_n.jpg?stp=cp6_dst-jpg_tt6&_nc_cat=110&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeGBgO_tSTUeEEZD0NntOwwdA0t51kIZRLUDS3nWQhlEtcgfUxBukAZcB5GTF3GJQjamdKUx93d6a0utykd6SOI3&_nc_ohc=n9LvzXlGNSoQ7kNvwH_S_Ni&_nc_oc=AdlgMMMwMW5x-ojVqRCOfTpbT9cTEO8Fdi_J8DA14ocD8eJPFfqGlyP9QW4aLMDZ6ZKjHQFVhBBqfVRcL35QGcd7&_nc_zt=23&_nc_ht=scontent-bom2-3.xx&_nc_gid=wHKUInAKeMvazz4OzY9Gkg&oh=00_AfOJVTgt_xtDv8B_0THtS5KlHWWF2_ta85igiZp8Xq6svA&oe=686369B1", url: "" },
    { name: "The Joy", logo: "https://scontent-bom1-1.xx.fbcdn.net/v/t39.30808-6/471175270_7037322719724614_1095201995000510305_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=127cfc&_nc_eui2=AeHb6JEtoOCeTTuh24qXRlzaEYF0QJptZoURgXRAmm1mhTCDGBAq7uMs9-jwdlsA_cGhwWaa5ERUw9JmLmd0cl7_&_nc_ohc=kPWJXZ8EWH4Q7kNvwFd7Ery&_nc_oc=AdmlrpR_PT7l54ljaAmapkeUialft5-O6RPf_nDghjxtB_I2jcqzquMjg6nCUOlCt8Q85VTua8VmrdzYJcBx9wYq&_nc_zt=23&_nc_ht=scontent-bom1-1.xx&_nc_gid=DvT3a_AQUSy45IUpqpd1UQ&oh=00_AfOoWv1jHJwYOHevRFbbuJXx5_ldfjsqbOuUtInxKG1xAQ&oe=68634D7B", url: "" },
  ];
  
  const regularCustomers = [
    { name: "Customer 1", logo: "https://pb.dailokrishi.com/api/files/pbc_710966215/8j10r8loq7v302k/customer1_ro71jyglvj.png?token=", url: "" },
    { name: "Customer 2", logo: "https://pb.dailokrishi.com/api/files/pbc_710966215/z90gb6b67hnux44/customer2_nwcrr5oxmv.png?token=", url: "" },
    { name: "Customer 3", logo: "https://pb.dailokrishi.com/api/files/pbc_710966215/ncfmudi63t974o9/customer3_4nzsuebwzi.png?token=", url: "" },
    { name: "Customer 4", logo: "https://pb.dailokrishi.com/api/files/pbc_710966215/e714lietg717cd6/customer5_8wof2cwr8q.png?token=", url: "" },
    { name: "Customer 5", logo: "https://pb.dailokrishi.com/api/files/pbc_710966215/87d40rumiyr0pq4/customer4_xwk5tthhr4.png?token=", url: "" },
  ];
  
  // Use provided customers or fall back to defaults based on product type
  const customersToDisplay = customers?.length
    ? customers
    : fallbackCustomers?.length
      ? fallbackCustomers
      : (isTea ? teaCustomers : regularCustomers);
  
  const getFontClass = () => {
    return locale === 'np' ? 'font-noto' : 'font-slate';
  };
  
  const getTitle = () => {
    // If a custom title is provided, use it
    if (title) return title;
    
    // Otherwise use default titles based on product type and language
    if (isTea) {
      return locale === 'np' ? 'हाम्रा चिया खरिदकर्ताहरू' : 'People Alike!';
    }
    
    return locale === 'np' ? 'सन्तुष्ट ग्राहकहरू' : 'Happy Customers';
  };
  
  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };
  
  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };
  
  const checkScrollPosition = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 5);
    }
  };
  
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', checkScrollPosition);
      // Check initial scroll position
      checkScrollPosition();
      
      return () => {
        scrollContainer.removeEventListener('scroll', checkScrollPosition);
      };
    }
  }, []);
  
  // Re-check when customers array changes
  useEffect(() => {
    checkScrollPosition();
  }, [customersToDisplay.length]);

  return (
    <section className="w-full py-10">
      <div className="max-w-[500px] mx-auto px-4">
        <h3 className={`text-[rgba(0,63,40,1)] text-4xl font-bold mb-6 text-center ${locale === 'en' ? 'font-slate' : 'font-noto'}`}>
          {getTitle()}
        </h3>
        
        <div className="relative">
          {showLeftArrow && (
            <button 
              onClick={scrollLeft}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-[rgba(0,63,40,0.8)] flex items-center justify-center text-white shadow-md hover:bg-[rgba(0,63,40,1)]"
              aria-label="Scroll left"
            >
              <ChevronLeft size={20} />
            </button>
          )}
          
          <div 
            ref={scrollContainerRef}
            className="overflow-x-auto pb-6 flex gap-6 snap-x snap-mandatory no-scrollbar scroll-smooth"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {customersToDisplay.map((customer, index) => (
              <div 
                key={index}
                className="flex-shrink-0 snap-center w-64 h-64 rounded-xl overflow-hidden shadow-md transition-transform duration-300 hover:shadow-xl hover:scale-[1.02]"
              >
                {customer.url ? (
                  <a
                    href={customer.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full h-full"
                    title={customer.name}
                  >
                    <img 
                      src={customer.logo} 
                      alt={customer.name}
                      className="w-full h-full object-cover" 
                    />
                  </a>
                ) : (
                  <img 
                    src={customer.logo} 
                    alt={customer.name}
                    className="w-full h-full object-cover"
                    title={customer.name}
                  />
                )}
              </div>
            ))}
            <div className="w-1 shrink-0" aria-hidden="true" />
          </div>
          
          {showRightArrow && (
            <button 
              onClick={scrollRight}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-[rgba(0,63,40,0.8)] flex items-center justify-center text-white shadow-md hover:bg-[rgba(0,63,40,1)]"
              aria-label="Scroll right"
            >
              <ChevronRight size={20} />
            </button>
          )}
        </div>
      </div>
    </section>
  );
};
